import { createFileRoute } from '@tanstack/react-router';
import { MemberSettingsIndex } from '@/pages/settings/MemberSettingsIndex';

// No route-level guard: every role sees the roster read-only. Write actions (invite, remove,
// role change) gate on companySettings.manageMembers inside the table and header.
export const Route = createFileRoute('/_authenticated/_app/settings/members')({
	component: MemberSettingsIndex,
});
